import React, { useRef, useEffect } from 'react'
import { createPortal } from 'react-dom'
import FocusTrap from 'focus-trap-react'
import { useSelector } from 'react-redux'
import CustomMap from './CustomMap'

import './modal.scss'

const MapModal = (props) => {
  const { show, handleHideModal, selectedSolOpp } = props
  const { modal } = useSelector((state) => state.common)
  const modalRef = useRef(null)

  useEffect(() => {
    if (show) {
      modalRef?.current?.focus()
      document.getElementById('root').setAttribute('aria-hidden', false)
      document.getElementsByTagName('body')[0].style.overflow = 'hidden'
    }

    return () => {
      modalRef?.current?.focus()
      document.getElementById('root').setAttribute('aria-hidden', false)
      document.getElementsByTagName('body')[0].style.overflow = 'initial'
    }
  }, [show])

  const children = (
    <div
      ref={modalRef}
      id="map-modal"
      className={
        show ? 'modal modal--fixed-height visible' : 'modal modal--fixed-height'
      }
      role="dialog"
      aria-modal="true"
      aria-labelledby="map-modal-title"
      tabIndex="-1"
    >
      <div className="modal-inner map-modal-respVoorgevel">
        <div className="modal-header">
          <button
            type="button"
            className="button close icon-cross modal-close"
            data-target="map-modal"
            onClick={handleHideModal}
            aria-expanded="false"
          >
            <span>Sluiten</span>
          </button>
        </div>
        <div className="modal-content solar-map-modal-content">
          <h3
            id="map-modal-title"
            dangerouslySetInnerHTML={{ __html: modal.solar_map_title }}
          />
          <p
            dangerouslySetInnerHTML={{ __html: modal.solar_map_description }}
          />
          <CustomMap selectedSolOpp={selectedSolOpp} />
        </div>
        <div className="modal-actions">
          <button
            type="button"
            className="button button-primary modal-close"
            data-target="modal-meerInfo"
            onClick={handleHideModal}
          >
            Terug naar het advies
          </button>
        </div>
      </div>
      <div
        className="modal-overlay modal-close"
        data-target="map-modal"
        tabIndex="-1"
        onMouseDown={handleHideModal}
        role="button"
        aria-label="modal"
      />
    </div>
  )

  return createPortal(
    show ? <FocusTrap>{children}</FocusTrap> : children,
    document.getElementsByTagName('body')[0],
  )
}
export default MapModal
